import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Toaster from "@meforma/vue-toaster";
var _ = require('lodash');
window.jQuery = require('jquery');
var FormData = require('form-data');
import { createI18n } from 'vue-i18n';
import FlagIcon from 'vue-flag-icon';
import moment from 'moment';
// import StarRating from 'vue-star-rating'


const i18n = createI18n({
  legacy: false,
  locale: "",
 globalInjection: true,
  messages: {
    en: {
      message: {
        language: "English",
        greeting: "Hello !",
        selectcategory: "Select Category",
        category: "Category",
        item: "Item",
        plustaxes: "plus taxes",
        proceed: "Proceed",
        add: "ADD +",
        cartempty: "Please add atleast one item!",
        orderstatus: " Order Status",
        help: " Call Waiter",
        orderdetails: "Order Details",
        totalamount: "Total Amount",
        placeorder: "Place Order",
        ordersuccess: "Order Successfully Placed.",
        orderno: "Order No",
        yourorder: "Your Order",
        qty: "QTY",
        price: "Price",
        viewbill: "View Bill",
        viewordersummary: "View All Summary",
        confirmed: "Confirmed Order List",
        new: "Pending Order List",
        browsemenu: "Browse Menu",
        getbill: "Get Bill",
        email: "Email Address",
        sendbill: "Send Bill",
        close: "Close",
        goodfood: "Good Food is always Cooking",
        emptycart: "Your cart is empty. Add something from the menu",
        readmore: "...read more",
        readless: " read less",
        join: "Join",
        joinorder: "Join Ongoing Order",
        start: "Tap to Start",
        name: "Enter Your Name",
        startnew: "Start New Order",
        or: "OR",
        entermail: "Please enter your email address",
        english: "English",
        thai: "Thai",
        japan: "Japanese",
        korea: "Korean",
        it: "Italian",
        ch: "Chinese (Simplified)",
        intouch: "Get In Touch",
        address: "Address",
        phone: "Phone",
        no_order: "Order not found.",
        cart_empty: "Add something from the menu and place the order.",
        out_of_stock: "Out of Stock",
        place_order: "Order has been placed by your partner.",
        revieworder: "Please review your order!",
        mail_success: "Mail sent Successfully!",
        mail_error:"Error sending mail!",
        wrongpin: "Invalid Pin",
        enterpin: "Enter Pin",
        tablepin: "Table Pin",
        ordertogether: "Order Together",
        sharepin: "Share PIN with your companions at table and order together.",
        addinstruction: "Add instruction.......",
        helpwaiter: "Request sent successfully!",
        orderid: "Order ID:",
        rate: "Rate",
        servicecharge: "Service Charge",
        paidamount: "Amount to be paid",
        paymentmode: "Payment Mode:",
        online: "Online",
        offline: "Offline",
        order: "Order",
        copyright: "Copyright",
        allrights: "All rights reserved.",
        finish: "Finish",
        alreadyprocced: "Please wait Transaction is already in proccess.",
        alreadypaid: "Your Payment for this order is done successfully. Please create a new session to order again",
        subtotal: "Sub Total",
        billtotal: "Bill Total",
        discount: "Discount",
        date: "Date:",
        time: "Time:",
        item_count: "Cannot add more than 50 items.",
        no_internet: "No Internet Access.",
        enter_name: "Please enter name.",
        enter_email: "Please enter email address.",
        enter_phone: "Please enter phone number.",
        customise_test: "Customize as per your taste",
        add_ons: "Add on's",
        add_to_cart: "Add to Cart",
        customize: "Customize",
        customer_details: "Customer Details",
        submit: "Submit",
        update_item: "Update Item",
        no_menu: "Menu Not Available!",
        tip: "Tip",
        other: "Other",
        entertip: "Enter Tip(%)",    
        addt: "ADD",
        tipyourwaiter: "Tip Your Waiter!",
        tipdesc: "Thank your waiter with a well-deserved tip.",
        entervalidemail: "Please enter valid email address.",
        submitfeedback: "Submit Feedback",
        givefeedback: "Give your feedback",  
        telluswhat: "Tell us what you liked....",
        feedback_success: "Thank You for Your Feedback.",
        noorderfound: "No order found.",
        pendingorder: "Pending Order",
        confirmedorder: "Confirmed Order", 
        cannotaddnegative: "Cannot add negative.",   
        clear: "clear",
        loading: "loading...",
        acceptterms: "Please accept terms & conditions and privacy policy.",  
        iagreetothe: "I agree to the",
        termsconditions: "Terms and Conditions",
        and: "and",
        privacypolicy: "Privacy Policy.",
      }
    },
    ro: {
      message: {
        language: "Romania",
        greeting: "test",
        selectcategory: "Selectați categoria",
        category: "Categorie",
        item: "Articol",
        plustaxes: "plus taxe",
        proceed: "Continuați",
        add: "Adăugați +",
        cartempty: "Vă rugăm să adăugați cel puțin un articol!",
        orderstatus: " Statutul comenzii",
        help: " Chemați chelnerul",
        orderdetails: "Detalii comandă",
        totalamount: "Suma totală",
        placeorder: "Plasați comanda",
        ordersuccess: "Comandă plasată cu succes.",
        orderno: "Comanda Nr.",
        yourorder: "Comanda Dvs.",
        qty: "Cantitate",
        price: "Preț",
        viewbill: "Vedeți Bill",
        viewordersummary: "Vezi tot rezumatul",
        confirmed: "Lista de comenzi confirmate",
        new: "Noua listă de comenzi",
        browsemenu: "Răsfoiți meniul",
        getbill: "Obțineți factura",
        email: "Adresa de e-mail",
        sendbill: "Trimiteți factura",
        close: "Închideți",
        goodfood: "Mâncarea bună se gătește întotdeauna",
        emptycart: "Coșul dumneavoastră este gol. Adăugați ceva din meniu.",
        readmore :"...Citiți mai mult",
        readless : " Citiți mai puțin",
        join: "Alăturați-vă",
        start: "Atingeți pentru a începe",
        joinorder: "Alăturați-vă comenzii în curs de desfășurare",
        name: "Introduceți numele Dvs.",
        startnew: "Inițiați o comandă nouă",
        or: "SAU",
        entermail: "Vă rugăm să introduceți adresa Dvs. de e-mail",
        english: "Engleza",
        thai: "thailandez",
        japan: "japonez",
        korea: "coreeană",
        it: "Italiană",
        ch: "Chineză simplificată)",
        intouch: "Luați legătura",
        address: "Adresa",
        phone: "Telefon",
        no_order: "Comanda nu a fost găsită.",
        cart_empty: "Adăugați ceva din meniu și plasați comanda.",
        place_order: "Comanda a fost plasată de către partenerul Dvs.",
        revieworder: "Vă rugăm să revizuiți comanda!",
        wrongpin: "PIN invalid",
        enterpin: "Introduceți PIN-ul",
        tablepin: "PIN-ul mesei",
        ordertogether: "Comandați împreună",
        sharepin: "Împărtășiți PIN-ul cu ceilalți de la masă și comandați împreună.",
        addinstruction: "Adăugați instrucțiuni......",
        helpwaiter: "Cerere trimisă cu succes!",
        orderid: "ID-ul comenzii:",
        rate: "Tarif",
        servicecharge: "Taxa de serviciu",
        paidamount: "Suma plătită",
        paymentmode: "Metoda de plată:",
        online: "Online",
        offline: "Offline",
        order: "Comandă",
        copyright: "Drepturi de autor",
        allrights: "Toate drepturile rezervate.",
        mail_success: "Mail trimis cu succes!",
        mail_error:"Eroare la trimiterea mail-ului!",
        finish: "finalizarea",
        subtotal: "Sumă parțială",
        billtotal: "Total factură",
        date: "Data:",
        time: "Timp:",
        item_count: "Nu se pot adăuga mai mult de 50 de articole.",
        no_internet: "Fără acces la internet.",
        enter_name: "Vă rugăm să introduceți numele.",
        enter_email: "Vă rugăm să introduceți adresa de e-mail.",
        enter_phone: "Vă rugăm să introduceți numărul de telefon.",
        out_of_stock: "Stoc epuizat",
        customise_test: "Personalizați după placul Dvs.",
        add_ons: "Adaosuri",
        add_to_cart: "Adăugați în coș",
        customize: "Personalizați",
        customer_details: "Detalii client",
        submit: "Trimiteți",
        update_item: "Actualizați articolul",
        no_menu: "Meniul nu este disponibil!",
        tip: "Bacșiș",
        other: "Altele",
        entertip: "Introduceți bacșișul (%)",    
        addt: "Adăugați",
        tipyourwaiter: "Lăsați bacșiș chelnerului Dvs!",
        tipdesc: "Lăsați bacșiș chelnerului pentru munca bine făcută. Mulțumiți-i chelnerului dându-i un bacșiș meritat, lăsându-i un bacșiș.",
        entervalidemail: "Vă rugăm să introduceți o adresă de e-mail validă.",
        submitfeedback: "Trimiteți feedback",
        givefeedback: "Lăsați-ne feedback-ul Dvs.",
        telluswhat: "Spuneți-ne ce v-a plăcut....",
        feedback_success: "Vă mulțumim pentru feedback-ul Dvs.",
        noorderfound: "Nu s-a găsit nicio comandă.",
        pendingorder: "Comandă în așteptare", 
        confirmedorder: "Comandă confirmată",
        cannotaddnegative: "Nu se pot adăuga valori negative",
        clear: "Ștergeți",
        loading: "Se încarcă...",
        acceptterms: "Vă rugăm să acceptați termenii și condițiile și politica de confidențialitate.",
        iagreetothe: "Sunt de acord cu",
        termsconditions: "Termeni si Conditii",
        and: "și",
        privacypolicy: "Politica de Confidențialitate.",
        discount: "Reducere"

      }
      },
    uk: {
      message: {
        language: "Україна",
        greeting: "Hello !",
        selectcategory: "Виберіть категорію",
        category: "Категорія",
        item: "Пункт",
        plustaxes: "плюс податки",
        proceed: "Продовжуйте",
        add: "ДОДАТИ +",
        cartempty: "Будь ласка, додайте хоча б один елемент!",
        orderstatus: " Статус замовлення",
        help: " Викликати офіціанта",
        orderdetails: "деталі замовлення",
        totalamount: "Загальна кількість",
        placeorder: "Зробити замовлення",
        ordersuccess: "Замовлення успішно розміщено.",
        orderno: "Номер замовлення",
        yourorder: "Ваше замовлення",
        qty: "КІЛЬКІСТЬ",
        price: "Ціна",
        viewordersummary: "Переглянути всі замовлення",
        confirmed: "Список підтверджених замовлень",
        new: "Список незавершених замовлень",
        browsemenu: "Меню перегляду",
        getbill: "Отримайте Білла",
        email: "Адреса електронної пошти",
        sendbill: "Надіслати рахунок",
        close: "Закрити",
        goodfood: "Хороша їжа – це завжди готування",
        emptycart: "Ваш кошик порожній. Додайте щось із меню",
        readmore: "...читати далі",
        readless: " читай менше",
        join: "Приєднуйтесь",
        joinorder: "Приєднуйтесь до поточного замовлення",
        start: "Торкніться, щоб почати",
        name: "Введіть ім'я",
        startnew: "Почати нове замовлення",
        or: "АБО",
        entermail: "Будь ласка, введіть свою електронну адресу",
        english: "англійська",
        thai: "тайська",
        japan: "японські",
        korea: "корейський",
        it: "італійська",
        ch: "китайська (спрощена)",
        intouch: "Зв'язатись",
        address: "Адреса",
        phone: "Телефон",
        no_order: "Замовлення не знайдено.",
        cart_empty: "Додайте щось із меню та зробіть замовлення.",
        out_of_stock: "Немає в наявності",
        place_order: "Замовлення зробив ваш партнер.",
        revieworder: "Будь ласка, перегляньте своє замовлення!",
        mail_success: "Лист успішно надіслано!",
        mail_error:"Помилка надсилання пошти!",
        wrongpin: "Недійсний PIN-код",
        enterpin: "Введіть PIN-код",
        tablepin: "Таблиця Pin",
        ordertogether: "Замовляйте разом",
        sharepin: "Поділіться PIN-кодом зі своїми супутниками за столом і замовляйте разом.",
        addinstruction: "Додати інструкцію......",
        helpwaiter: "Запит успішно надіслано!",
        orderid: "Ідентифікатор замовлення:",
        rate: "Оцінити",
        servicecharge: "Плата за послуги",
        paidamount: "Сплачена сума",
        paymentmode: "Режим оплати:",
        online: "Онлайн",
        offline: "Офлайн",
        order: "Замовити",
        copyright: "Авторське право",
        allrights: "Всі права захищені.",
        finish: "Закінчити",
        alreadyprocced: "Будь ласка, зачекайте. Трансакція вже виконується.",
        alreadypaid: "Ваш платіж за це замовлення здійснено успішно. Будь ласка, створіть новий сеанс, щоб знову замовити",
        subtotal: "Проміжний підсумок",
        billtotal: "Загальний рахунок",
        discount: "Знижка",
        date: "Дата:",
        time: "Час:",
        item_count: "Не можна додати більше 50 елементів.",
        no_internet: "Немає доступу до Інтернету.",
        enter_name: "Будь ласка, введіть ім'я.",
        enter_email: "Будь ласка, введіть адресу електронної пошти.",
        enter_phone: "Будь ласка, введіть номер телефону.",
        customise_test: "Налаштуйте на свій смак",
        add_ons: "Додатки",
        add_to_cart: "Додати в кошик",
        customize: "Налаштувати",
        customer_details: "Інформація про клієнта",
        submit: "Подати",
        update_item: "Оновити елемент",
        no_menu: "Меню недоступне!",
        tip: "Порада",
        other: "Інший",
        entertip: "Введіть чайові (%)",    
        addt: "ДОДАТИ",
        tipyourwaiter: "Чай Вашому офіціанту!",
        tipdesc: "Чай офіціанту за добре виконану роботу. Подякуйте своєму офіціанту, давши їм заслужені чайові, залишивши їм чайові.",
        entervalidemail: "Введіть дійсну електронну адресу.",
        submitfeedback: "Надіслати відгук",
        givefeedback: "Дайте свій відгук",  
        telluswhat: "Розкажіть, що вам сподобалося....",
        feedback_success: "Спасибі за ваш відгук.",
        noorderfound: "Замовлення не знайдено.",
        pendingorder: "Відкладене замовлення",
        confirmedorder: "Підтверджене замовлення", 
        cannotaddnegative: "Неможливо додати мінус.",   
        clear: "ясно",
        loading: "завантаження...",
        acceptterms: "Прийміть умови та політику конфіденційності.",  
        iagreetothe: "Я згоден на",
        termsconditions: "Правила та умови",
        and: "і",
        privacypolicy: "Політика конфіденційності.",
        viewbill: "Переглянути рахунок"
        

      }
    },
    th: {
      message: {
        language: "Thailand",
        greeting: "test",
        selectcategory: "เลือกประเภท",
        category: "หมวดหมู่",
        item: "รายการ",
        plustaxes: "บวกภาษี",
        proceed: "ดำเนินการ",
        add: "เพิ่ม +",
        cartempty: "กรุณาเพิ่มอย่างน้อยหนึ่งรายการ!",
        orderstatus: " สถานะการสั่งซื้อ",
        help: " เรียกบริกร",
        orderdetails: "รายละเอียดการสั่งซื้อ",
        totalamount: "จำนวนเงินทั้งหมด",
        placeorder: "สถานที่การสั่งซื้อ",
        ordersuccess: "วางคำสั่งซื้อเรียบร้อยแล้ว",
        orderno: "เลขที่ใบสั่งซื้อ",
        yourorder: "คำสั่งของคุณ",
        qty: "จำนวน",
        price: "ราคา",
        viewordersummary: "ดูสรุปคำสั่งซื้อ",
        confirmed: "ยืนยันรายการสั่งซื้อ",
        new: "รายการสั่งซื้อใหม่",
        browsemenu: "เรียกดูเมนู",
        getbill: "รับบิล",
        email: "ที่อยู่อีเมล",
        sendbill: "ส่งบิล",
        close: "ปิด I",
        goodfood: "อาหารอร่อยเสมอการปรุงอาหาร",
        emptycart: "รถเข็นของคุณว่างเปล่า เพิ่มบางอย่างจากเมนู",
        readmore: "อ่านเพิ่มเติม",
        readless: " อ่านน้อยลง",
        join: "เข้าร่วม",
        start: "แตะเพื่อเริ่ม",
        joinorder: "เข้าร่วมการสั่งซื้ออย่างต่อเนื่อง",
        name: "ใส่ชื่อของคุณ",
        startnew: "เริ่มคำสั่งซื้อใหม่",
        or: "หรือ",
        entermail: "กรุณากรอกอีเมลของคุณ",
        english: "ภาษาอังกฤษ",
        thai: "ไทย",
        japan: "ญี่ปุ่น",
        korea: "เกาหลี",
        it: "ภาษาอิตาลี",
        ch: "ภาษาจีน (ตัวย่อ)",
        intouch: "ได้รับการติดต่อ",
        address: "ที่อยู่",
        phone: "โทรศัพท์",
        no_order: "ไม่พบคำสั่งซื้อ",
        cart_empty: "เพิ่มบางอย่างจากเมนูและสั่งซื้อ",
        place_order: "คำสั่งซื้อได้รับการสั่งซื้อโดยคู่ค้าของคุณ",
        revieworder: "โปรดตรวจสอบคำสั่งซื้อของคุณ!",
        wrongpin: "Pin ไม่ถูกต้อง",
        enterpin: "ป้อนพิน",
        tablepin: "ขาโต๊ะ",
        ordertogether: "สั่งซื้อด้วยกัน",
        sharepin: "แบ่งปัน PIN กับเพื่อนของคุณที่โต๊ะและสั่งซื้อด้วยกัน",
        addinstruction: "เพิ่มคำสั่ง.......",
        helpwaiter: "ส่งคำขอเรียบร้อยแล้ว!",
        orderid: "รหัสคำสั่งซื้อ:",
        rate: "ประเมินค่า",
        servicecharge: "ค่าบริการ",
        paidamount: "จำนวนเงินที่ชำระ",
        paymentmode: "โหมดการชำระเงิน:",
        online: "ออนไลน์",
        offline: "ออฟไลน์",
        order: "คำสั่ง",
        copyright: "ลิขสิทธิ์",
        allrights: "สงวนลิขสิทธิ์.",
        finish: "เสร็จ"

      }
    },

    ja: {
      message: {
        language: "Japan",
        greeting: "test",
        selectcategory: "カテゴリを選んでください",
        category: "カテゴリー",
        item: "アイテム",
        plustaxes: "プラス税",
        proceed: "続行",
        add: "追加 +",
        cartempty: "少なくとも1つのアイテムを追加してください！",
        orderstatus: " 注文の状況",
        help: " ウェイターに電話する",
        orderdetails: "注文詳細",
        totalamount: "合計金額",
        placeorder: "注文する",
        ordersuccess: "注文が正常に行われました。",
        orderno: "注文番号",
        yourorder: "ご注文",
        qty: "数量",
        price: "価格",
        viewordersummary: "注文の概要を表示",
        confirmed: "確認済み注文リスト",
        new: "新しい注文リスト",
        browsemenu: "メニューを閲覧する",
        getbill: "ビルを取得",
        email: "電子メールアドレス",
        sendbill: "請求書を送る",
        close: "選ぶ",
        goodfood: "おいしい料理は常に料理です",
        emptycart: "あなたのカートは空です。メニューから何かを追加します",
        readmore :"続きを読む",
        readless : " 続きを読む",
        join: "加入",
        start: "タップして開始",
        joinorder: "進行中の注文に参加する",
        name: "あなたの名前を入力してください",
        startnew: "新規注文を開始",
        or: "また",
        entermail: "メールアドレスを入力してください",
        english: "英語",
        thai: "タイ語",
        japan: "日本",
        korea: "韓国語",
        it: "イタリアの",
        ch: "中国語簡体字",
        intouch: "連絡する",
        address: "住所",
        phone: "電話",
        no_order: "注文が見つかりません。",
        cart_empty: "メニューから何かを追加して注文します。",
        place_order: "パートナーから注文がありました。",
        revieworder: "ご注文内容をご確認ください。",
        wrongpin: "無効なピン",
        enterpin: "PINを入力してください",
        tablepin: "テーブルピン",
        ordertogether: "一緒に注文する",
        sharepin: "PINをテーブルで仲間と共有し、一緒に注文します。",
        addinstruction: "命令を追加......。",
        helpwaiter: "リクエストは正常に送信されました！",
        orderid: "注文ID:",
        rate: "割合",
        servicecharge: "サービス料",
        paidamount: "支払金額",
        paymentmode: "支払いモード：",
        online: "オンライン ",
        offline: "オフライン",
        order: "注文",
        copyright: "著作権",
        allrights: "全著作権所有。",
        finish: "終了"

      }
      },
      it: {
      message: {
        language: "Italy",
        greeting: "test",
        selectcategory: "Seleziona categoria",
        category: "Categoria",
        item: "Articolo",
        plustaxes: "più tasse",
        proceed: "Procedere",
        add: "Inserisci +",
        cartempty: "Si prega di aggiungere almeno un elemento!",
        orderstatus: " Lo stato dell'ordine",
        help: " Chiama il cameriere",
        orderdetails: "Dettagli dell'ordine",
        totalamount: "Importo totale",
        placeorder: "Invia ordine",
        ordersuccess: "Ordine effettuato con successo.",
        orderno: "Numero d'ordine",
        yourorder: "Il tuo ordine",
        qty: "QTY",
        price: "Prezzo",
        viewordersummary: "Vedeți Bill",
        confirmed: "Lista ordini confermati",
        new: "Nuovo elenco ordini",
        browsemenu: "Sfoglia il menu",
        getbill: "Ottieni Bill",
        email: "Indirizzo email",
        sendbill: "Invia fattura",
        close: "Chiudere",
        goodfood: "Il buon cibo è sempre in cucina",
        emptycart: "Il tuo carrello è vuoto. Aggiungi qualcosa dal menu",
        readmore :"Per saperne di più",
        readless : " Leggi di meno",
        join: "aderire",
        start: "tocca per iniziare",
        joinorder: "unisciti all'ordine in corso",
        name: "Inserisci il tuo nome",
        startnew: "inizia un nuovo ordine",
        or: "o",
        entermail: "Inserisci il tuo indirizzo email",
        english: "inglese",
        thai: "tailandese",
        japan: "giapponese",
        korea: "Coreana",
        it: "italiana",
        ch: "cinese semplificato",
        intouch: "Mettiti in contatto",
        address: "Indirizzo",
        phone: "Telefono",
        no_order: "Nessun ordine trovato.",
        cart_empty: "Aggiungi qualcosa dal menu e fai l'ordine.",
        place_order: "L'ordine è stato effettuato dal tuo partner.",
        revieworder: "Si prega di rivedere il tuo ordine!",
        wrongpin: "Pin non valido",
        enterpin: "Inserisci Pin",
        tablepin: "spilla da tavola",
        ordertogether: "Ordina insieme",
        sharepin: "Condividi il PIN con i tuoi compagni di tavola e ordina insieme.",
        addinstruction: "Aggiungi istruzione.......",
        helpwaiter: "Richiesta inviata con successo!",
        orderid: "ID ordine:",
        rate: "Valutare",
        servicecharge: "Costo del servizio",
        paidamount: "Importo pagato",
        paymentmode: "Metodo di pagamento:",
        online: "in linea",
        offline: "Disconnesso",
        order: "Ordine",
        copyright: "Diritto d'autore",
        allrights: "Tutti i diritti riservati.",
        finish: "Fine"

      }
      },
      ko: {
      message: {
        language: "Korean",
        greeting: "test",
        selectcategory: "카테고리 선택",
        category: "범주",
        item: "안건",
        plustaxes: "플러스 세금",
        proceed: "진행하다",
        add: "추가하다 +",
        cartempty: "항목을 하나 이상 추가하십시오!",
        orderstatus: " 주문 상태",
        help: " 콜 웨이터",
        orderdetails: "주문 세부정보",
        totalamount: "총액",
        placeorder: "주문하기",
        ordersuccess: "주문이 완료되었습니다.",
        orderno: "주문 번호",
        yourorder: "주문",
        qty: "수량",
        price: "가격",
        viewordersummary: "주문 요약 보기",
        confirmed: "확인된 주문 목록",
        new: "새 주문 목록",
        browsemenu: "메뉴 찾아보기",
        getbill: "청구서 받기",
        email: "이메일 주소",
        sendbill: "청구서 보내기",
        close: "닫다",
        goodfood: "좋은 음식은 항상 요리입니다",
        emptycart: "장바구니가 비어 있습니다. 메뉴에서 무언가 추가",
        readmore :"더 읽기",
        readless : " 덜 읽다",
        join: "가입하다",
        start: "탭하여 시작",
        joinorder: "진행중인 주문에 합류",
        name: "당신의 이름을 입력",
        startnew: "새로운 주문을 시작하다",
        or: "또는",
        entermail: "당신의 이메일 주소를 입력하십시오",
        english: "영어",
        thai: "태국어",
        japan: "일본어",
        korea: "한국인",
        it: "이탈리아 사람",
        ch: "중국어 (간체)",
        intouch: "연락하기",
        address: "주소",
        phone: "핸드폰",
        no_order: "주문을 찾을 수 없습니다.",
        cart_empty: "메뉴에서 무언가를 추가하고 주문하십시오.",
        place_order: "파트너가 주문했습니다.",
        revieworder: "주문을 검토하십시오!", 
        wrongpin: "잘못된 핀",
        enterpin: "핀 입력",
        tablepin: "테이블 핀",
        ordertogether: "함께 주문",
        sharepin: "테이블에서 동료와 PIN을 공유하고 함께 주문하십시오.",
        addinstruction: "명령어 추가.......",
        helpwaiter: "요청이 성공적으로 전송되었습니다!",
        orderid: "주문 아이디:",
        rate: "비율",
        servicecharge: "서비스 비용",
        paidamount: "지불 금액",
        paymentmode: "결제 모드:",
        online: "온라인",
        offline: "오프라인",
        order: "주문하다",
        copyright: "저작권",
        allrights: "판권 소유.",
        finish: "마치다"

      }
      },
      zh: {
      message: {
        language: "China",
        greeting: "test",
        selectcategory: "选择类别",
        category: "类别",
        item: "物品",
        plustaxes: "加税",
        proceed: "继续",
        add: "添加 +",
        cartempty: "请至少添加一项！",
        orderstatus: " 订单状态",
        help: " 呼叫服务员",
        orderdetails: "订单详细信息",
        totalamount: "总金额",
        placeorder: "下订单",
        ordersuccess: "订单已成功下达。",
        orderno: "订单号",
        yourorder: "您的订单",
        qty: "数量",
        price: "价钱",
        viewordersummary: "查看订单摘要",
        confirmed: "确认订单清单",
        new: "新订单清单",
        browsemenu: "浏览菜单",
        getbill: "拿账单",
        email: "电子邮件地址",
        sendbill: "发送账单",
        close: "关闭",
        goodfood: "美食总是在烹饪",
        emptycart: "您的购物车是空的。从菜单中添加内容",
        readmore :"阅读更多",
        readless : " 少读",
        join: "加入",
        start: "点击开始",
        joinorder: "加入正在进行的订单",
        name: "输入你的名字",
        startnew: "开始新订单",
        or: "或者",
        entermail: "请输入您的电子邮件地址",
        english: "英语",
        thai: "泰国",
        japan: "日本人",
        korea: "韩国人",
        it: "意大利语",
        ch: "简体中文",
        intouch: "保持联系",
        address: "地址",
        phone: "电话",
        no_order: "未找到订单。",
        cart_empty: "从菜单中添加一些东西并下订单。",
        place_order: "您的合作伙伴已下订单。",
        revieworder: "请检查您的订单！",
        wrongpin: "无效的引脚",
        enterpin: "输入密码",
        tablepin: "表针",
        ordertogether: "一起订购",
        sharepin: "与餐桌上的同伴分享 PIN 码并一起订购。",
        addinstruction: "添加说明......",
        helpwaiter: "请求发送成功！",
        orderid: "订单编号:",
        rate: "速度",
        servicecharge: "服务费",
        paidamount: "已付金额",
        paymentmode: "付款方式:",
        online: "在线的",
        offline: "离线",
        order: "命令",
        copyright: "版权",
        allrights: "版权所有。",
        finish: "结束"
      }
      },
        ru: {
          message: {
            language: "Russian",
            greeting: "test",
            selectcategory: "выбрать категорию",
            category: "Категория",
            item: "Пункт",
            plustaxes: "плюс налоги",
            proceed: "Продолжить",
            add: "ДОБАВИТЬ +",
            cartempty: "Пожалуйста, добавьте хотя бы один товар!",
            orderstatus: " Статус заказа",
            help: " Вызовите официанта",
            orderdetails: "Информация для заказа",
            totalamount: "Общее количество",
            placeorder: "Разместить заказ",
            ordersuccess: "Заказ успешно размещен.",
            orderno: "№ заказа",
            yourorder: "Твоя очередь",
            qty: "КОЛ-ВО",
            price: "Цена",
            viewordersummary: "Посмотреть сводку заказа",
            confirmed: "Список подтвержденных заказов",
            new: "Новый список заказов",
            browsemenu: "Обзор меню",
            getbill: "Получить Билл",
            email: "Адрес электронной почты",
            sendbill: "Отправить счет",
            close: "Закрывать",
            goodfood: "Хорошая еда всегда готовит",
            emptycart: "Ваша корзина пуста. Добавить что-нибудь из меню",
            readmore :"...читать далее",
            readless : " читать меньше",
            join: "Присоединиться",
            start: "Нажмите, чтобы начать",
            joinorder: "Присоединиться к текущему заказу",
            name: "Введите ваше имя",
            startnew: "Начать новый заказ",
            or: "ИЛИ",
            entermail: "Пожалуйста, введите Ваш адрес электронной почты",
            english: "английский",
            thai: "Тайский",
            japan: "японский язык",
            korea: "корейский язык",
            it: "итальянский",
            ch: "Китайский (упрощенный)",
            intouch: "Связаться",
            address: "Адрес",
            phone: "Телефон",
            no_order: "Заказ не найден.",
            cart_empty: "Добавьте что-нибудь из меню и оформите заказ.",
            out_of_stock: "Распродано",
            place_order: "Заказ был размещен вашим партнером.",
            revieworder: "Пожалуйста, проверьте ваш заказ!",
            mail_success: "Почта успешно отправлена!",
            mail_error: "Ошибка отправки почты!",
            wrongpin: "Неверный PIN-код",
            enterpin: "Введите пин-код",
            tablepin: "Пин таблицы",
            ordertogether: "Заказывайте вместе",
            sharepin: "Поделитесь PIN-кодом с вашими компаньонами за столом и заказывайте вместе.",
            addinstruction: "Добавить инструкцию .......",
            helpwaiter: "Запрос успешно отправлен!",
            orderid: "номер заказа:",
            rate: "Ставка",
            servicecharge: "Плата за обслуживание",
            paidamount: "Выплаченная сумма",
            paymentmode: "Режим оплаты:",
            online: "онлайн ",
            offline: "Не в сети",
            order: "Заказ",
            copyright: "авторское право",
            allrights: "Все права защищены.",
            finish: "Заканчивать",
    
          }
          },
      

    es: {
      message: {
        language: "Español",
        greeting: "Hola !"
      }
    }
  }
});


// createApp(App).use(store).use(router).mount('#app')
const app = createApp(App).use(i18n).use(FlagIcon).use(moment).use(store).use(router)

app.config.globalProperties.axios=axios
app.config.globalProperties.jQuery=window.jQuery
app.config.globalProperties.formdata=FormData
app.config.globalProperties.lodash=_
app.component("font-awesome-icon", FontAwesomeIcon)
// app.component("StarRating", StarRating)
app.use(Toaster)
app.mount('#app')
